export default __webpack_public_path__ + "static/media/reorder.92091ec9.svg";